import moment from 'moment';

// Day starts at 3:00am so night card goes until late
const isToday = timeString => {
  if (!timeString) {
    return false;
  }
  const time = moment(timeString);
  const startOfDay = moment();
  if (startOfDay.hour() < 3) {
    startOfDay.subtract(1, 'day');
  }
  startOfDay
    .hour(3)
    .minute(0)
    .seconds(0);
  return time.isAfter(startOfDay);
};

// Morning 3:00am - 10:59am -> 3 - 10
// Day 11:00am - 6:59pm -> 11 - 18
// Night 7:00pm - 2:59am -> 19 - 2
const currentTimeOfDay = () => {
  const hour = moment().hour();
  if (hour < 3 || hour > 18) {
    return 'night';
  }
  if (hour > 10) {
    return 'day';
  }
  return 'morning';
};

export { isToday, currentTimeOfDay };
